import { createRoute } from '@tanstack/react-router';
import { PlanovaniPage } from '@/modules/servis/PlanovaniPage';
import { Route as RootRoute } from './__root';

interface PlanovaniSearch {
  offset?: number;
}

function parsePlanovaniSearch(input: Record<string, unknown>): PlanovaniSearch {
  const raw = input.offset;
  if (raw === undefined || raw === '') return {};
  const n = typeof raw === 'number' ? raw : parseInt(String(raw), 10);
  if (Number.isFinite(n) && n !== 0) return { offset: n };
  return {};
}

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/servis/planovani',
  component: PlanovaniPage,
  validateSearch: parsePlanovaniSearch,
});
